import { render } from "./chrome.vue?vue&type=template&id=632d01b2"
import script from "./chrome.vue?vue&type=script&lang=js"
export * from "./chrome.vue?vue&type=script&lang=js"

import "./chrome.vue?vue&type=style&index=0&id=632d01b2&lang=css"
script.render = render

export default script